import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { UserCompany } from '../../core/types';

export const COMPANIES: UserCompany[] = [
  {
    name: 'Client name 1',
    company_id: 'a7f335e9',
    ManualUploadNeeded: false,
    DATEVExportNeeded: false,
  },
  {
    name: 'Client name 2',
    company_id: 'a7f335e7',
    ManualUploadNeeded: false,
    DATEVExportNeeded: false,
  },
  {
    name: 'Client name 3',
    company_id: 'a7f335e8',
    ManualUploadNeeded: false,
    DATEVExportNeeded: false,
  },
];

const TaxAdvisorContext = createContext<{
  company?: UserCompany;
  onCompanyClick: (id: string) => () => void;
}>({ company: undefined, onCompanyClick: (id: string) => () => {} });

export function TaxAdvisorWrapper({ children }: PropsWithChildren<{}>) {
  const [companyId, setCompanyId] = useState('a7f335e9');
  const company = COMPANIES.find((c) => c.company_id === companyId);
  const onCompanyClick = (id: string) => () => {
    setCompanyId(id);
  };

  return (
    <TaxAdvisorContext.Provider
      value={{
        company,
        onCompanyClick,
      }}
    >
      {children}
    </TaxAdvisorContext.Provider>
  );
}

export function useTaxAdvisor() {
  return useContext(TaxAdvisorContext);
}
